<template>
  <div class="index">
    <!-- 顶部信息模块 开始 -->
    <div class="index-total-module">
      <div class="index-total-module-item module-item1">
        <ul class="module-item-lists">
          <li class="module-item-list"> 
			<router-link tag="a" to="/reportOverView">
          <div class="moduleData">
              <div class="img">
                <img src="../../assets/images/index/todayVisitor.png" alt="">
              </div>
              <div>
			  	        <p class="name">今日访客量</p>
                	<p class="num">{{ todayData.visitorVolumeToday }}</p>
              </div>
          </div>
			</router-link>
          </li>
          <li class="module-item-list">
			<router-link tag="a" to="/history">
          <div class="moduleData">
              <div class="img">
                <img src="../../assets/images/index/conversationVolume.png" alt="">
              </div>
              <div>
                  <p class="name">人工会话量</p>
                  <p class="num">{{ today.callData }}</p>
              </div>
          </div>
			</router-link>
          </li>
          <li class="module-item-list">
			<router-link tag="a" to="/history">
          <div class="moduleData">
              <div class="img">
                <img src="../../assets/images/index/machineConversation.png" alt="">
              </div>
              <div>
			        	<p class="name">机器人会话量</p>
                <p class="num">{{ today.robotCallingNum }}</p>
              </div>
          </div>
			</router-link>
          </li>
          <li class="module-item-list">
			<router-link tag="a" to="/tobeprocessed-order-list">
          <div class="moduleData">
              <div class="img">
                <img src="../../assets/images/index/beSolvedNum.png" alt="">
              </div>
              <div>
				        <p class="name">待解决工单数</p>
                <p class="num">{{ todayData.toBeSolvedCount }}</p>
              </div>
          </div>
			</router-link>
          </li>
          <li class="module-item-list">
			<router-link tag="a" to="/resolved-order-list">
          <div class="moduleData">
              <div class="img">
                <img src="../../assets/images/index/resolvedNum.png" alt="">
              </div>
              <div>
			  	      <p class="name">已解决工单数</p>
               	<p class="num">{{ todayData.resolvedCount }}</p>
              </div>
          </div>
			</router-link>
          </li>
          <li class="module-item-list">
			<router-link tag="a" to="/closed-order-list">
          <div class="moduleData">
              <div class="img">
                <img src="../../assets/images/index/closedNum.png" alt="">
              </div>
              <div>
			  	        <p class="name">已关闭工单数</p>
               		<p class="num">{{ todayData.notResolvedCount }}</p>
              </div>
          </div>
			</router-link>
          </li>
          <!-- <li class="module-item-list">
            <p class="num">{{ todayData.leaveData }}</p>
            <p class="name">待回复的留言</p>
          </li>
          <li class="module-item-list">
            <p class="num">{{ todayData.callback }}</p>
            <p class="name">待回电的客户</p>
          </li> -->
        </ul>
      </div>
      <div class="index-total-module-item module-item2">
        <p class="module-item-title-border-right order">
          近7日工单情况
          <el-popover
            placement="right"
            width="100"
            style="margin-left: 5px;vertical-align: middle;float:right;"
            trigger="hover"
          >
            <span style="font-size: 12px;color: #333;"
              >近7日工单情况，包含每日已解决工单数、每日关闭工单数和每日新增工单数</span
            >
            <span slot="reference"><i class="el-icon-info" style="color:#969AA7;"></i></span>
          </el-popover>
        </p>
        <lineChartOrder
          v-if="Object.keys(workOrderSituation).length > 0"
          height="215px"
          id="overview-service-workOrder-charts"
          :chartData="workOrderSituation"
        ></lineChartOrder>
      </div>
    </div>
    <div class="index-notice-module">
      <!-- <div class="index-notice-module-left">
        <ul class="noticeLists">
          <li class="noticeList notice-company">
            <div class="title">
              <p>公司公告</p>
                <p class="more">
                    <router-link tag="a" to="/company-notice" class="login-register-logo">更多公告
                    </router-link>
                </p>
            </div>
            <div class="content">
              <ul v-if="noticeList.length">
                <li class="system" v-for="item in noticeList" :key="item.createTime">
					<router-link tag="a" to="/company-notice">
						<span class="boll"></span>
						<p>{{item.content}}</p>
						<span class="version-update-time">{{item.showCreateTime}}</span>
					</router-link>
                </li>
              </ul>
			  <p v-else class="noData">暂无数据</p>
            </div>
          </li>
          <li class="noticeList notice-system">
            <div class="title">
              <p>系统公告</p>
                <p class="more">
                    <router-link tag="a" to="setting-notice" class="login-register-logo">更多公告
                    </router-link>
                </p>
            </div>
            <div class="content">
              <ul v-if="versionList.length">
                <li class="system" v-for="item in versionList" :key="item.updateNum">
					<router-link tag="a" to="setting-notice">
						<span class="boll"></span>
						<p>微聊 {{item.version}} 版本更新</p>
						<span class="version-update-time">{{item.date}}</span>
					</router-link>
                </li>
              </ul>
			  <p v-else class="noData">暂无数据</p>
            </div>
          </li>
        </ul>
      </div> -->
      <div class="index-notice-module-right">
        <el-tabs v-model="activeTypeName" @tab-click="typeSwitchClick">
          <el-tab-pane label="工单处理" name="first"></el-tab-pane>
          <el-tab-pane label="今日客服活动" name="second"></el-tab-pane>
        </el-tabs>
        <div v-show="activeTypeName == 'first'">
            <div class="circleBox">
              <p class="topTip">智能小助手</p>
               <div class="progressBox">
                 <el-progress type="circle" :color="customColor" :stroke-width="10" :show-text="false" v-if="!isNaN(Math.round(resolvedListNum*100/allNums))" :percentage="Math.round(resolvedListNum*100/allNums)"></el-progress>
                 <div class="progressNav">
                    <p><span>{{resolvedListNum}}</span>项</p>
                    <p>待处理</p>
                 </div>
               </div>
               <div class="progressBtn" v-show="resolvedListNum > 0">
                 <el-button type="primary" @click="gohandleClick">去处理</el-button>
               </div>
            </div>
            <div class="tableBox">
              <p class="more">
                  <router-link tag="a" to="tobeprocessed-order">更多
                  </router-link>
              </p>
              <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
                <el-tab-pane label="待分配工单" name="first"></el-tab-pane>
                <el-tab-pane label="待处理工单" name="second"></el-tab-pane>
                <el-tab-pane label="已解决工单" name="third"></el-tab-pane>
                <el-tab-pane label="已关闭工单" name="fourth"></el-tab-pane>
                <el-tab-pane label="我的工单" name="fifth"></el-tab-pane>
              </el-tabs>
              <div class="table">
                <ul class="table_title">
                  <li>标题</li>
                  <li>分配客服</li>
                  <li>提交时间</li>
                  <li>最后回复时间</li>
                </ul>
                <div class="table_content">
                  <ul class="table_lists" v-if="orderCenter.lists.length">
                    <li class="listsBox" v-for="(item,index) in orderCenter.lists" :key="item.id">
                      <ul class="lists">
                      <li class="list" :class="{'open':orderCenter.judges[index]}" @click="openChnage(orderCenter.judges[index],index)">
                          <p :title="item.title">{{item.title}}</p>
                        </li>
                        <li class="list"><p><span v-if="item.assignedCsName">{{item.assignedCsName}}</span><span style="color:#FF691F;" v-else>未分配</span></p></li>
                        <li class="list"><p>{{item.createTime}}</p></li>
                        <li class="list"><p>{{item.updateTime}}</p></li>
                      </ul>
                    </li>
                  </ul>
                  <p v-else class="noData">暂无数据</p>
                </div> 
              </div>
            </div>
        </div>
        <div class="tableCell" v-show="activeTypeName == 'second'">
            	<div class="index-evaluate-analyze index-services-activity publicBgs">
        <!-- <p class="module-item-title-border-left">今日客服活动</p> -->
              <p class="more">
                  <router-link to="service-today-activity">更多
                  </router-link>
              </p>
              <el-table
                v-loading="isLoading"
                stripe
                :data="tableData"
                :header-cell-style="{ background: '#f7f7f7' }"
                style="width: 100%;border: 1px solid #ebeef5;margin-top: 20px;"
              >
                <el-table-column width="50" label="客服">
                  <template slot-scope="scope">
                    <img
                      class="table-image table-image-avatar "
                      :src="avatarX(scope.row.csHeadimg)"
                      alt="客服头像"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="csName" label=""> </el-table-column>
                <el-table-column prop="isOnline" align="center" label="在线状态">
                  <template slot-scope="scope">
                    <div class="onlineSta" v-if="scope.row.isOnline == 0">
                      <img :src="imgOffline" v-if="scope.row.isOnline == 0" alt="" />
                      <span class="onlineStatus offline">{{
                        scope.row.isOnlineStr
                      }}</span>
                    </div>
                    <div class="onlineSta" v-if="scope.row.isOnline == 1">
                      <img
                        :src="pcOnImg"
                        v-if="scope.row.showPcIcon == 1"
                        class="mgt5"
                        alt="PC端"
                      />
                      <img
                        :src="clientOnImg"
                        v-if="scope.row.showClientIcon == 1"
                        class="mgt5"
                        alt=""
                      />
                      <img
                        :src="mobileOnImg"
                        v-if="scope.row.showAppIcon == 1"
                        alt=""
                      />
                      <span class="onlineStatus online">{{
                        scope.row.isOnlineStr
                      }}</span>
                    </div>
                    <div class="onlineSta" v-if="scope.row.isOnline == 2">
                      <img
                        :src="pcOffImg"
                        v-if="scope.row.showPcIcon == 1"
                        class="mgt5"
                        alt=""
                      />
                      <img
                        :src="clientOffImg"
                        v-if="scope.row.showClientIcon == 1"
                        class="mgt5"
                        alt=""
                      />
                      <img
                        :src="mobileOffImg"
                        v-if="scope.row.showAppIcon == 1"
                        alt=""
                      />
                    <span class="onlineStatus rest">{{ scope.row.isOnlineStr }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="todayCumulativeTime" label="今日在线时长">
              </el-table-column>
              <el-table-column prop="receptionNum" label="实时接待人数">
              </el-table-column>
              <el-table-column prop="maxNum" width="80" label="接待上限">
              </el-table-column>
              <el-table-column prop="callingNum" width="80" label="会话量">
              </el-table-column>
              <el-table-column prop="avgcalltimeData" label="平均接待时长">
              </el-table-column>
            </el-table>
            <!-- <pagenations :total="total" :size="pageSize" @pageHandler="pageOperate">
            </pagenations> -->
          </div>
        </div>
      </div>
      <div class="index-notice-module-left">
        <div class="noticeTop">
          <el-tabs v-model="activeTypeNum" @tab-click="typeSwitchNumClick">
            <el-tab-pane label="昨日下单量" name="first"></el-tab-pane>
            <el-tab-pane label="昨日访问量" name="second"></el-tab-pane>
          </el-tabs>
          <div class="order-statistical-module" v-show="activeTypeNum=='first'">
            <div class="pie-chat">
              <div id="pieChartGoods" class="pie-chat-goods"></div>
            </div>
            <div class="pie-detail">
              <div class="pie-detail-item">
                <i class="circle-icon"></i>
                <div>
                  <div class="pie-detail-num">
                    {{shopDataYesterday.marketingGoodsScale ?
                    Math.round(shopDataYesterday.marketingGoodsScale * 100) : '0'}}%
                  </div>
                  <div class="pie-detail-title">
                    营销活动({{shopDataYesterday.marketingGoodsNum ?
                    shopDataYesterday.marketingGoodsNum : '0'}}笔)
                  </div>
                </div>
              </div>
              <div class="pie-detail-item">
                <i class="circle-icon otherColor"></i>
                <div>
                  <div class="pie-detail-num">
                    {{shopDataYesterday.normalGoodsScale ?
                    Math.round(shopDataYesterday.normalGoodsScale * 100) : '0'}}%
                  </div>
                  <div class="pie-detail-title">
                    普通商品({{shopDataYesterday.normalGoodsNum ?
                    shopDataYesterday.normalGoodsNum : '0'}}笔)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order-statistical-module" v-show="activeTypeNum =='second'">
          <div class="pie-chat">
            <div id="pieChartVisitor" class="pie-chat-visitor"></div>
          </div>
          <div class="pie-detail">
            <div class="pie-detail-item">
              <i class="circle-icon"></i>
              <div>
                <div class="pie-detail-num">
                  {{shopDataYesterday.totalAccessNum ?
                  (shopDataYesterday.totalAccessNum == 0 ? '0' :
                  Math.round((shopDataYesterday.olderUserAccessNum / shopDataYesterday.totalAccessNum)
                  * 100)) : '0'}}%
                </div>
                <div class="pie-detail-title">
                  老用户({{shopDataYesterday.olderUserAccessNum ?
                  shopDataYesterday.olderUserAccessNum : '0'}}人)
                </div>
              </div>
            </div>
            <div class="pie-detail-item">
              <i class="circle-icon otherColors"></i>
              <div>
                <div class="pie-detail-num">
                  {{shopDataYesterday.totalAccessNum ?
                  (shopDataYesterday.totalAccessNum == 0 ? '0' :
                  Math.round((shopDataYesterday.newUserAccessNum / shopDataYesterday.totalAccessNum) *
                  100)) : '0'}}%
                </div>
                <div class="pie-detail-title">
                  新用户({{shopDataYesterday.newUserAccessNum ?
                  shopDataYesterday.newUserAccessNum : '0'}}人)
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="noticeBottom">
            <div class="block">
              <span class="demonstration">工具</span>
              <el-carousel height="135px"  :interval="10000" arrow="never">
                <el-carousel-item>
                  <ul>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-advanced-reply-company">
                          <div class="img">
                            <img src="@/assets/images/index/IntelReply.png" alt="">
                          </div>
                        </router-link>
                        <p>快捷回复</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-join-wxapp">
                          <div class="img">
                            <img src="@/assets/images/index/appletsImg.png" alt="">
                          </div>
                        </router-link>
                        <p>小程序</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-join-gzh">
                          <div class="img">
                            <img src="@/assets/images/index/officialAccount.png" alt="">
                          </div>
                        </router-link>
                        <p>公众号</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-online-distribution-rules">
                          <div class="img">
                            <img src="@/assets/images/index/sessionAssignment.png" alt="">
                          </div>
                        </router-link>
                        <p>会话分配</p>
                      </div>
                    </li>
                  </ul>
                </el-carousel-item>
                <el-carousel-item >
                  <ul>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/reportShopData">
                          <div class="img">
                            <img src="@/assets/images/index/shopData.png" alt="">
                          </div>
                        </router-link>
                        <p>商城数据</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/shopconfig">
                          <div class="img">
                            <img src="@/assets/images/index/shopingTips.png" alt="">
                          </div>
                        </router-link>
                        <p>下单通知</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-online-satisfaction">
                          <div class="img">
                            <img src="@/assets/images/index/evaluateLabel.png" alt="">
                          </div>
                        </router-link>
                        <p>评价标签</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-advanced-knowledge-management">
                          <div class="img">
                            <img src="@/assets/images/index/knowledgeBase.png" alt="">
                          </div>
                        </router-link>
                        <p>知识库</p>
                      </div>
                    </li>
                    <li>
                      <div class="carousrBox">
                        <router-link to="/setting-join-website-mob">
                          <div class="img">
                            <img src="@/assets/images/index/chatIcon.png" alt="">
                          </div>
                        </router-link>
                        <p>聊天图标设置</p>
                      </div>
                    </li>
                  </ul>
                </el-carousel-item>
              </el-carousel>
            </div>
        </div>
      </div>
    </div>
    <!-- <div class="index-total-analyze" v-if="0">
      <div class="index-total-analyze-item publicBg">
        <div class="total-analyze-item-icon">
          <svg-icon icon-class="visitorNum"></svg-icon>
        </div>
        <div class="total-analyze-item-desc">
          <div class="desc-count">{{ today.visitorNum }}</div>
          <p class="desc-title">今日访客量</p>
        </div>
      </div>
      <div class="index-total-analyze-item publicBg">
        <div class="total-analyze-item-icon">
          <svg-icon icon-class="manService"></svg-icon>
        </div>
        <div class="total-analyze-item-desc">
          <div class="desc-count">{{ today.callData }}</div>
          <p class="desc-title">人工会话量</p>
        </div>
      </div>
      <div class="index-total-analyze-item publicBg">
        <div class="total-analyze-item-icon">
          <svg-icon icon-class="robotMsg"></svg-icon>
        </div>
        <div class="total-analyze-item-desc">
          <div class="desc-count">{{ today.robotCallingNum }}</div>
          <p class="desc-title">机器人会话量</p>
        </div>
      </div>
      <div class="index-total-analyze-item publicBg">
        <div class="total-analyze-item-icon">
          <svg-icon icon-class="leaveMsg"></svg-icon>
        </div>
        <div class="total-analyze-item-desc">
          <div class="desc-count">{{ today.leaveData }}</div>
          <p class="desc-title">留言量</p>
        </div>
      </div>
      <div class="index-total-analyze-item publicBg">
        <div class="total-analyze-item-icon">
          <svg-icon icon-class="onlineService"></svg-icon>
        </div>
        <div class="total-analyze-item-desc">
          <div class="desc-count">{{ today.onlineNum }}</div>
          <p class="desc-title">在线客服人数</p>
        </div>
      </div>
    </div> -->
    <!-- 顶部信息模块 结束 -->
	<!-- <div class="analyze-wrap">
		<div class="index-service-analyze publicBg">
		  <p class="module-item-title-border-left">
		    分时段访客统计<el-popover
		      placement="right"
		      width="400"
		      style="margin-left: 5px;vertical-align: middle;"
		      trigger="hover"
		    >
		      <span style="font-size: 12px;color: #333;"
		        >今日截止当前更新时间，不同时段的访客量统计</span
		      >
		      <span slot="reference"><i class="el-icon-info"></i></span>
		    </el-popover>
		  </p>
		  <barChart
		    v-if="Object.keys(visitorCountChartData).length > 0"
		    height="380px"
		    id="overview-service-count-charts"
		    :chartData="visitorCountChartData"
		  ></barChart>
		</div>
		<div class="index-service-analyze publicBg">
		  <p class="module-item-title-border-left">
		    分时段会话情况<el-popover
		      placement="right"
		      width="400"
		      style="margin-left: 5px;vertical-align: middle;"
		      trigger="hover"
		    >
		      <span style="font-size: 12px;color: #333;"
		        >今日截止当前更新时间，不同时段的会话量、未回复量和留言量统计</span
		      >
		      <span slot="reference"><i class="el-icon-info"></i></span>
		    </el-popover>
		  </p>
		  <lineChart
		    v-if="Object.keys(tendencyChartData).length > 0"
		    height="380px"
		    id="overview-service-tendency-charts"
		    :chartData="tendencyChartData"
		  ></lineChart>
		</div> -->
		<!-- <div class=" index-evaluate-analyze publicBg">
		  <p class="module-item-title-border-left">访客区域分布图</p>
		  <div class="index-map">
		    <mapChart
		      class="area-map"
		      height="480px"
		      id="visotor-area-charts"
		      :width="'60%'"
		      :chartData="areaData"
		    ></mapChart>
		    <el-table
		      :data="areaData.slice(0, 10)"
		      class="area-data"
		      :header-cell-style="{ background: '#f2f2f2' }"
		      border
		      stripe
		    >
		      <el-table-column type="index" width="50"> </el-table-column>
		      <el-table-column prop="name" label="省份" width="180">
		      </el-table-column>
		      <el-table-column prop="count" label="访客数">
		        <template slot-scope="scope">
		          <div class="data-detail">
		            <div class="countNum">{{ scope.row.value }}</div>
		            <el-progress
		              v-if="false"
		              class="progressBar"
		              :show-text="false"
		              :stroke-width="13"
		              :percentage="Number(scope.row.value / areaMaxCount)"
		            ></el-progress>
		          </div>
		        </template>
		      </el-table-column>
		    </el-table>
		  </div>
		</div>
		<div class="index-evaluate-analyze publicBg" v-if="false">
		  <p class="module-item-title-border-left">每日评价人数趋势</p>
		  <lineChart
		    v-if="Object.keys(commentTendencyChartData).length > 0"
		    height="380px"
		    id="overview-comment-tendency-charts"
		    :chartData="commentTendencyChartData"
		  ></lineChart>
		</div>
		<div class="index-evaluate-analyze index-services-activity publicBg">
		  <p class="module-item-title-border-left">今日客服活动</p>
		  <p class="more">
		      <router-link to="service-today-activity">查看更多
		      </router-link>
		  </p>
		  <el-table
		    v-loading="isLoading"
		    stripe
		    :data="tableData"
		    :header-cell-style="{ background: '#f2f2f2' }"
		    style="width: 100%;border: 1px solid #ebeef5;margin-top: 20px;"
		  >
		    <el-table-column width="50" label="客服">
		      <template slot-scope="scope">
		        <img
		          class="table-image table-image-avatar "
		          :src="avatarX(scope.row.csHeadimg)"
		          alt="客服头像"
		        />
		      </template>
		    </el-table-column>
		    <el-table-column prop="csName" label=""> </el-table-column>
		    <el-table-column prop="isOnline" align="center" label="在线状态">
		      <template slot-scope="scope">
		        <div class="onlineSta" v-if="scope.row.isOnline == 0">
		          <img :src="imgOffline" v-if="scope.row.isOnline == 0" alt="" />
		          <span class="onlineStatus offline">{{
		            scope.row.isOnlineStr
		          }}</span>
		        </div>
		        <div class="onlineSta" v-if="scope.row.isOnline == 1">
		          <img
		            :src="pcOnImg"
		            v-if="scope.row.showPcIcon == 1"
		            class="mgt5"
		            alt="PC端"
		          />
		          <img
		            :src="clientOnImg"
		            v-if="scope.row.showClientIcon == 1"
		            class="mgt5"
		            alt=""
		          />
		          <img
		            :src="mobileOnImg"
		            v-if="scope.row.showAppIcon == 1"
		            alt=""
		          />
		          <span class="onlineStatus online">{{
		            scope.row.isOnlineStr
		          }}</span>
		        </div>
		        <div class="onlineSta" v-if="scope.row.isOnline == 2">
		          <img
		            :src="pcOffImg"
		            v-if="scope.row.showPcIcon == 1"
		            class="mgt5"
		            alt=""
		          />
		          <img
		            :src="clientOffImg"
		            v-if="scope.row.showClientIcon == 1"
		            class="mgt5"
		            alt=""
		          />
		          <img
		            :src="mobileOffImg"
		            v-if="scope.row.showAppIcon == 1"
		            alt=""
		          />-->
		          <!--<img :src="imgHold" alt=""> -->
		          <!-- <span class="onlineStatus rest">{{ scope.row.isOnlineStr }}</span>
		        </div>
		      </template>
		    </el-table-column>
		    <el-table-column prop="todayCumulativeTime" label="今日在线时长">
		    </el-table-column>
		    <el-table-column prop="receptionNum" label="实时接待人数">
		    </el-table-column>
		    <el-table-column prop="maxNum" width="80" label="接待上限">
		    </el-table-column>
		    <el-table-column prop="callingNum" width="80" label="会话量">
		    </el-table-column>
		    <el-table-column prop="avgcalltimeData" label="平均接待时长">
		    </el-table-column>
		  </el-table> -->
		  <!-- <pagenations :total="total" :size="pageSize" @pageHandler="pageOperate">
		  </pagenations> -->
		<!-- </div> -->
		<!-- <div class="index-evaluate-analyze  publicBg">
		  <p class="module-item-title-border-left">首次响应时间</p>
		  <div
		    id="overview-response-time-charts"
		    style="height: 480px;width: 100%;"
		  ></div>
		</div>
		<div class="index-evaluate-analyze  publicBg">
		  <p class="module-item-title-border-left">留言解决率</p>
		  <div
		    id="overview-leavewords-solve-charts"
		    style="height: 480px;width: 100%;"
		  ></div>
		</div> -->
	<!-- </div> -->
    
  </div>
</template>

<script>
import echarts from "echarts";

import pagenations from "@/components/pagenations/pagenations";

import lineChart from "@/components/echarts/line-charts";
import lineChartOrder from "@/components/echarts/line-charts-order";
import barChart from "@/components/echarts/bar-charts";
import pieChart from "@/components/echarts/pie-charts";
import mapChart from "@/components/echarts/map-charts";

import avatar0 from "@/assets/images/client_avatar_empty.png";
import avatar1 from "@/assets/images/client_avatar1.png";
import avatar2 from "@/assets/images/client_avatar2.png";
import avatar3 from "@/assets/images/client_avatar3.png";
import avatar4 from "@/assets/images/client_avatar4.png";
import avatar5 from "@/assets/images/client_avatar5.png";
import avatar6 from "@/assets/images/client_avatar6.png";
import avatar7 from "@/assets/images/client_avatar7.png";

import imgHold from "@/assets/images/icon_server_holdon.png";
import imgOffline from "@/assets/images/icon_server_offline.png";
import imgOnline from "@/assets/images/icon_server_online.png";
import pcOnImg from "@/assets/images/icon_pc_on.png";
import pcOffImg from "@/assets/images/icon_pc_off.png";
import clientOnImg from "@/assets/images/icon_client_on.png";
import clientOffImg from "@/assets/images/icon_client_off.png";
import mobileOnImg from "@/assets/images/icon_mobile_on.png";
import mobileOffImg from "@/assets/images/icon_mobile_off.png";

export default {
  name: "index",
  components: {
    lineChart,
    lineChartOrder,
    pieChart,
    mapChart,
    pagenations,
    barChart
  },
  data() {
    return {
      chart:null,
      noticeList: [],//公司公告
      versionList: [],//微聊版本更新数据
      beginDate:'',//开始时间
      endDate:'',//结束时间
      activeName: "first", //默认选项卡
      activeTypeName:"first",
      activeTypeNum:'first',
      areaData: [],
      areaMaxCount: 0,
      satisfiesChartData: {},
      tableHandler: [
        { label: "查看详情", type: "operate", methods: "operateMethods" }
      ],
      tableData: [],
      visitorCountChartData: {},
      tendencyChartData: {},
      commentTendencyChartData: {},
      workOrderSituation: {}, //近七日工单情况
      firstRespondChartData: {}, //首次响应时间
      leaveSolveChartData: {}, //留言解决率
      orderCenter:{
          judges:[1,1,1,1,1,1,1,1],//判断数组
          lists:{}//表格内容
      },//工单中心
      toBeDistributedList:{},//待分配工单
      toBeProcessedList:{},//待处理工单
      resolvedList:{},//已解决工单
      closedList:{},//已关闭工单
      mineList:{},//我的工单
      startTime: "",
      endTime: "",
      setDate: "lastday", //响应时间默认昨天
      pageSize: 10,
      currentPage: 1,
      total: 0,
      isLoading: false,
      today: {
        avgcalltimeData: "0",
        callData: "0",
        leaveData: "0",
        uncallData: "0",
        visitorNum: "0"
      },
      // 首页顶部六个模块信息
      todayData: {
        toBeSolvedCount: "0",
        resolvedCount: "0",
        notResolvedCount: "0",
        leaveData: "0",
        callback: "0",
        visitorVolumeToday: "0"
      },
      lastday: {
        avgcalltimeData: "0",
        callData: "0",
        leaveData: "0",
        uncallData: "0",
        visitorNum: "0"
      },
      imgHold: imgHold,
      imgOffline: imgOffline,
      imgOnline: imgOnline,
      pcOnImg: pcOnImg,
      pcOffImg: pcOffImg,
      clientOnImg: clientOnImg,
      clientOffImg: clientOffImg,
      mobileOnImg: mobileOnImg,
      mobileOffImg: mobileOffImg,
      shopDataYesterday: {},
      shopDataDayBeforeYesterday: {},
      chart:null,
      resolvedListNum:0,
      allNums:0,
      customColor:'#1183ED'
    };
  },
  created() {
    this.initIndexData();
  },
  mounted() {
    eventBus.$on("reloadIndexTable", () => {
      this.getServiceActiveData();
    });
    this.getShopData()
  },
  methods: {
    // 切换表格
    handleClick(tab) {
      let index = tab.index;
      this.orderCenter.judges = [1,1,1,1,1,1,1,1]
      switch (index) {
        case "0":
          this.orderCenter.lists = this.toBeDistributedList
          break;
        case "1":
          this.orderCenter.lists = this.toBeProcessedList
          break;
        case "2":
          this.orderCenter.lists = this.resolvedList
          break;
        case "3":
          this.orderCenter.lists = this.closedList
          break;
        case "4":
          this.orderCenter.lists = this.mineList
          break;
      }
    },
    typeSwitchClick(tab, event){
      console.log(tab.index,event)
    },
    typeSwitchNumClick(tab, event){
      console.log(tab.index,event)
    },
    gohandleClick(){
       this.$router.push({path: "/tobeprocessed-order-list"});
    },
    openChnage(val,index){
        this.$set(this.orderCenter.judges, index, !val);
    },
    getShopData() {
      this.$http.getShopDataAPI({mallType:0}).then(res => {
        if (res.status == 1) {
          this.shopDataYesterday = res.data.yesterday;
          this.shopDataDayBeforeYesterday = res.data.dayBeforeYesterday;
        } else if(res.status != 1 && res.status != 0){
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
        let orderData = [
          {
            name: "营销活动",
            value: this.shopDataYesterday.marketingGoodsNum || 0
          },
          {
            name: "普通商品",
            value: this.shopDataYesterday.normalGoodsNum || 0
          }
        ];
        let visitorData = [
          {
            name: "新用户",
            value: this.shopDataYesterday.newUserAccessNum || 0
          },
          {
            name: "老用户",
            value: this.shopDataYesterday.olderUserAccessNum || 0
          }
        ];
        this.initPieCharts(
          "pieChartGoods",
          "昨日下单总数",
          this.shopDataYesterday.totalPurchaseNum || 0,
          orderData
        );
        this.initPieChartsed(
          "pieChartVisitor",
          "昨日访问总数",
          this.shopDataYesterday.totalAccessNum || 0,
          visitorData
        );
      });
    },
    initPieCharts(id, title, resultNum, data) {
      this.chart = echarts.init(
        document.getElementById(id)
      );
      this.chart.setOption({
        color: ["#1B75FB", "#E9C527"],
        title: {
          text: title,
          subtext: resultNum.toString(),
          left: "center",
          top: "center",
          textStyle: {
            fontSize: 12,
            color: "#999999",
            align: "center"
          },
          subtextStyle: {
            fontFamily: "微软雅黑",
            fontSize: 13,
            color: "#333"
          }
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: function(params, ticket, callback) {
            let num = params.value;
            let chartTitle = params.name;
            return `<div style="text-align: center;"><div style="color: #fff;">${chartTitle}</div><div style="color: #fff;padding-top: 5px;font-weight: bold;">${num}</div></div> `;
          },
          textStyle: {
            color: "#fff"
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            hoverAnimation: true, //关闭 hover 在扇区上的放大动画效果。
            cursor: "default", //鼠标悬浮时在图形元素上时鼠标的样式是什么。同 CSS 的 cursor。
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: data
          }
        ]
      });
    },
    initPieChartsed(id, title, resultNum, data) {
      this.chart = echarts.init(
        document.getElementById(id)
      );
      this.chart.setOption({
        color: [ "#01A887" , "#428efe"],
        title: {
          text: title,
          subtext: resultNum.toString(),
          left: "center",
          top: "center",
          textStyle: {
            fontSize: 12,
            color: "#999999",
            align: "center"
          },
          subtextStyle: {
            fontFamily: "微软雅黑",
            fontSize: 13,
            color: "#333"
          }
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: function(params, ticket, callback) {
            let num = params.value;
            let chartTitle = params.name;
            return `<div style="text-align: center;"><div style="color: #fff;">${chartTitle}</div><div style="color: #fff;padding-top: 5px;font-weight: bold;">${num}</div></div> `;
          },
          textStyle: {
            color: "#fff"
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            hoverAnimation: true, //关闭 hover 在扇区上的放大动画效果。
            cursor: "default", //鼠标悬浮时在图形元素上时鼠标的样式是什么。同 CSS 的 cursor。
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: data
          }
        ]
      });
    },
    // 初始化饼状图表
    initPieChart() {
      this.chart = echarts.init(
        document.getElementById("overview-response-time-charts")
      );
      let chartData = this.firstRespondChartData;
      let legendData = [];
      let seriesData = [];
      for (let key in chartData) {
        legendData.push(key);
        seriesData.push({
          name: key,
          value: chartData[key]
        });
      }
      this.chart.setOption({
        color: ["#fd6666", "#f2c900", "#63c756", "#4da3ff", "#8060fc"],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}%"
        },
        legend: {
          left: "0",
          top: "10",
          orient: "vertical",
          data: legendData
        },
        series: [
          {
            name: this.chartTitle,
            type: "pie",
            roseType: "radius",
            align: "left",
            data: seriesData,
            animationEasing: "cubicInOut",
            animationDuration: 2600
          }
        ]
      });
    },
    // 初始化环状图表
    initCircleChart() {
      this.chart = echarts.init(
        document.getElementById("overview-leavewords-solve-charts")
      );
      let chartData = this.leaveSolveChartData;
      let legendData = [];
      let seriesData = [];
      for (let key in chartData) {
        legendData.push(key);
        seriesData.push({
          name: key,
          value: chartData[key]
        });
      }
      this.chart.setOption({
        color: ["#fd6666", "#63c756"],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}%"
        },
        legend: {
          left: "0",
          top: "10",
          orient: "vertical",
          data: legendData
        },
        series: [
          {
            name: this.chartTitle,
            type: "pie",
            roseType: "radius",
            align: "left",
            radius: ["40%", "70%"],
            data: seriesData,
            animationEasing: "cubicInOut",
            animationDuration: 2600
          }
        ]
      });
    },
    /**
     * 首次响应时间
     */
    getOverviewFirstResponedData() {
      this.$http
        .getOverviewFirstResponedDataAPI({
          startTime: this.startTime,
          endTime: this.endTime,
          date: this.setDate
        })
        .then(res => {
          if (res.status == 1) {
            let data = res.data;
            this.firstRespondChartData = data;
            this.initPieChart();
          }
        });
    },
    /**
     * 留言解决率
     */
    getOverviewLeaveSolveData() {
      this.$http
        .getOverviewLeaveSolveDataAPI({
          startTime: this.startTime,
          endTime: this.endTime,
          date: this.setDate
        })
        .then(res => {
          if (res.status == 1) {
            let data = res.data;
            let newObj = {};
            for (let key in data) {
              if (key == "solve") {
                newObj["解决"] = data[key];
              } else {
                newObj["未解决"] = data[key];
              }
            }
            this.leaveSolveChartData = newObj;
            this.initCircleChart();
          }
        });
    },
    /**
     * 表单操作
     * @param val
     */
    handleOperate(val) {
      this.$router.push({
        path: "/index-detail",
        query: {
          id: val.csId
        }
      });
    },
    /**
     *  分页操作
     * @param val
     */
    pageOperate(val) {
      if (val.type == "currentChange") {
        this.currentPage = val.val;
      } else if (val.type == "sizeChange") {
        this.pageSize = val.val;
      }
      this.getServiceActiveData();
    },
    /**
     * 显示访客头像
     * 截取头像名称中的数字
     */
    avatarX(avatar) {
      const img = avatar.substring(avatar.length - 5, avatar.length - 4);
      switch (img) {
        case "y":
          return avatar0;
          break;
        case "1":
          return avatar1;
          break;
        case "2":
          return avatar2;
          break;
        case "3":
          return avatar3;
          break;
        case "4":
          return avatar4;
          break;
        case "5":
          return avatar5;
          break;
        case "6":
          return avatar6;
          break;
        case "7":
          return avatar7;
          break;
        default:
          return avatar;
          break;
      }
    },
    initIndexData() {
      this.getOverviewData();
      this.getServiceActiveData();
      this.getchartData();
      this.getOverviewSatisfiesData();
      // this.getCommentChartData()
      this.IndexStatistical();
      this.IndexNational();
      //this.getOverviewFirstResponedData();  // 暂时先去掉
     // this.getOverviewLeaveSolveData();    // 暂时先去掉
      this.TotalTicketsCount();
      this.SevenDayTicketsCount();
      this.TicketsCenter();
      this.getVersionList();
      this.getNoticeList();
    },
    
    /**
     * 获取版本号列表
     */
    getVersionList() {
        this.$http.noticeAPI({
            pageNum: 1,
            pageSize:this.size
        }).then(res => {
            if (res.status == 1) {
            let version = res.data.data
            this.versionList = version
            }
        }).catch(err => {
            console.log('err=', err)
        })
    },
    
    /**
     * 获取公司公告列表
     */
    getNoticeList() {
        this.$http.companyNoticeListAPI({
            currentPage: 1,
            pageSize: this.size
        }).then(res => {
            if (res.status == 1) {
                console.log(res.data.page)
                this.noticeList = res.data.page;
            }
        }).catch(err => {
            console.log('err=', err)
        })
    },
    // 首页顶部相关工单数据
    TotalTicketsCount(){
        this.$http.getTotalTicketsCountAPI({
            beginDate:this.beginDate,
            endDate:this.beginDate
        }).then(res => {
            // console.log(res)
            if (res.status == 1) {
                this.todayData = res.data
            }
      });
    },
    // 近七日工单详情
    SevenDayTicketsCount(){
        this.$http.getSevenDayTicketsCountAPI({
            beginDate:this.beginDate,
            endDate:this.beginDate
        }).then(res => {
            console.log(res.data)
            if (res.status == 1) {
                this.workOrderSituation = res.data
            }
      });
    },
    // 工单中心
    TicketsCenter(){
        this.$http.getTicketsCenterAPI({
            beginDate:this.beginDate,
            endDate:this.beginDate
        }).then(res => {
            console.log(res)
            if (res.status == 1) {
                this.toBeDistributedList=res.data.toBeDistributedList.filter(function(item,index){
                    return index<4
                })//待分配工单
                this.toBeProcessedList=res.data.toBeProcessedList.filter(function(item,index){
                    return index<4
                }) //待处理工单
                this.resolvedListNum = res.data.resolvedList.length
                this.allNums =res.data.toBeDistributedList.length + res.data.toBeProcessedList.length + res.data.resolvedList.length + res.data.closedList.length +res.data.mineList.length +5;
                this.resolvedList=res.data.resolvedList.filter(function(item,index){
                    return index<4
                }) //已解决工单
                this.closedList=res.data.closedList.filter(function(item,index){
                    return index<4
                }) //已关闭工单
                this.mineList=res.data.mineList.filter(function(item,index){
                    return index<4
                }) //我的工单
                // console.log(this.toBeDistributedList)
                this.orderCenter.lists = this.toBeDistributedList
            }
      });
    },
    // 分时段访客数统计
    IndexStatistical() {
      this.$http.IndexStatisticalAPI().then(res => {
        if (res.status == 1) {
          this.visitorCountChartData = res.data;
        }
      });
    },
    getOverviewData() {
      this.$http.IndexOverviewAPI({
          keyword: "today"
        }).then(todayRes => {
          if (todayRes.status == 1) {
            let todayData = todayRes.data;
            this.today = todayData;
          }
        });
      // this.$http.IndexOverviewAPI({
      //     keyword: 'lastday'
      // }).then(yestodayRes => {
      //     if (yestodayRes.status == 1) {
      //         let yestodayData = yestodayRes.data
      //         this.$http.IndexOverviewAPI({
      //             keyword: 'today'
      //         }).then(todayRes => {
      //             if (todayRes.status == 1) {
      //                 let todayData = todayRes.data
      //                 this.today = todayData
      //                 this.lastday = yestodayData
      //             }
      //         })
      //     }
      // })
    },
    getchartData() {
      this.$http.getOverviewOnlineTendencyDataAPI({
          date: "today"
        }).then(res => {
          if (res.status == 1) {
            let data = res.data;
            delete data.visitor;
            this.tendencyChartData = data;
          }
        });
    },
    getCommentChartData() {
      this.$http.getOverviewCommentTendencyDataAPI({
          date: "today"
        }).then(res => {
          if (res.status == 1) {
            let data = res.data;
            let newObj = {};
            for (let key in data) {
              if (key == "goodEvaluate") {
                newObj["1"] = data[key];
              } else if (key == "middleEvaluate") {
                newObj["2"] = data[key];
              } else if (key == "badEvaluate") {
                newObj["3"] = data[key];
              } else if (key == "allEvaluate") {
                newObj["4"] = data[key];
              } else if (key == "time") {
                newObj["time"] = data[key];
              }
            }
            this.commentTendencyChartData = newObj;
          }
        });
    },
    getServiceActiveData() {
      this.$http.IndexServiceActiveAPI({
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }).then(res => {
          if (res.status == 1) {
            // this.tableData = res.data.cserviceList;
            this.tableData = res.data.cserviceList.filter(function(item,index){
                return index<6
            })
            this.total = res.data.total;
          }
        });
    },
    /**
     * 环比计算
     * @param today
     * @param yestoday
     * @returns {string}
     */
    chaninFn(today, yestoday) {
      let result = "";
      if (yestoday == 0) {
        result = "—";
      } else {
        result = (((today - yestoday) / yestoday) * 100).toFixed(1) + "%";
      }
      return result;
    },
    /**
     * 好评-差评
     */
    getOverviewSatisfiesData() {
      this.$http.getOverviewSatisfiesDataAPI({
          date: "today"
        }).then(res => {
          if (res.status == 1) {
            let data = res.data;
            let key = Object.keys(data),
              val = Object.values(data).filter(item => item === 0);
            if (key.length === val.length) {
              this.satisfiesChartData = {};
            } else {
              this.satisfiesChartData = data;
            }
          }
        });
    },
    objOfValueToArr(object) {
      var arr = [];
      var i = 0;
      for (var item in object) {
        arr[i] = object[item];
        i++;
      }
      return arr;
    },
    IndexNational() {
      this.$http.IndexNationalAPI().then(res => {
        if (res.status == 1) {
          let maxNumArr = [];
          res.data.map((item, i) => {
            maxNumArr.push(item.value);
          });
          this.areaMaxCount = Math.max(...maxNumArr);
          res.data.map(item => {
            if (item.name.indexOf("新疆") != -1) {
              item.name = "新疆";
            }
            if (item.name.indexOf("内蒙古") != -1) {
              item.name = "内蒙古";
            }
            if (item.name.indexOf("宁夏") != -1) {
              item.name = "宁夏";
            }
            if (item.name.indexOf("西藏") != -1) {
              item.name = "西藏";
            }
            if (item.name.indexOf("广西") != -1) {
              item.name = "广西";
            }
            if (item.name.indexOf("香港") != -1) {
              item.name = "香港";
            }
            if (item.name.indexOf("澳门") != -1) {
              item.name = "澳门";
            }
          });
          this.areaData = res.data;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.index {
  padding:0 0 25px 25px!important;
  .index-total-module {
    width: 100%;
    height: 300px;
    margin-bottom: 6px;
    .module-item1 {
      float: left;
      width: 67%;
      height: 100%;
      .module-item-lists {
        width: 100%;
        height: 100%;
        padding-left: 0;
        overflow: hidden;
        .module-item-list {
          float: left;
          width: calc(33.333% - 10px);
          height: 140px;
          background-color: #fff;
          margin-bottom: 10px;
          margin-right: 10px;
          border-radius: 6px;
          .num {
            font-size: 28px;
            text-align: center;
            color: $mainColor;
            line-height: 1;
          }
          .name {
            color: #333;
            font-size: 14px;
            text-align: center;
            line-height: 1;
            margin: 20px 0 8px;
          }
          .moduleData{
            height: 140px;
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            padding-left: calc(18% - 10px);
            .img{
              width: 88px;
              height: 88px;
              margin-right: calc(12% - 8px);
              img{
                width: 100%;
                height: 100%;
                display: block;
              }
            }
          }
        }
      }
    }
    .module-item2 {
      float: left;
      width: calc(33% - 30px);
      height: 290px; 
      padding: 25px 15px 0;
      background-color: #fff;
      position: relative;
      border-radius: 6px;
      .order {
        border-left: 0;
        line-height: 30px;
        font-weight: normal;
        font-size: 14px;
        position: absolute;
        left: 10px;
        z-index: 2;
        width: calc(100% - 20px);
        top: 22px;
      }
      #overview-service-tendency-charts,#overview-service-workOrder-charts{
        margin-top:25px;
      }
    }
  }
  .index-notice-module {
    ul {
      padding-left: 0;
    }
    width: 100%;
    height: 465px;
    margin-bottom: 20px;
    .index-notice-module-left {
      float: left;
      height: 100%;
      width: calc(33% - 30px);
      .noticeTop{
        width: 100%;
        height: 250px;
        background: #fff;
        padding: 0 26px;
        box-sizing: border-box;
        border-radius: 6px;
        .el-tabs__header {
          padding: 4px 0 0;
          .el-tabs__nav-wrap {
            &::after {
              height: 1px;
              background-color: #e6e6e6;
            }
            .el-tabs__nav-scroll {
              margin-left: 10px;
              .el-tabs__nav {
                height: 38px;
                .el-tabs__active-bar {
                  background-color: #50566D;
                  height: 2px;
                }
                .el-tabs__item {
                  line-height: 37px;
                  color: #50556D!important;
                  &.is-active {
                    color: #50556D!important;
                    font-weight: bold!important;
                  }
                  &:hover {
                    color: #50556D!important;
                    font-weight: bold!important;
                  }
                }
              }
              .el-tabs__item{
                padding: 0 14px;
              }
            }
          }
        }
        .order-statistical-module {
          width: 100%;
          padding: 12px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .pie-chat {
            .pie-chat-goods,
            .pie-chat-visitor {
              width: 173px;
              height: 173px;
            }
          }

          .pie-detail {
            .pie-detail-item + .pie-detail-item {
              margin-top: 30px;
            }

            .pie-detail-item {
              display: flex;
              align-items: center;
              .circle-icon {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #1B75FB;
                margin-top: 8px;
                margin-right: 10px;
                &.otherColor {
                  background-color: #E9C527;
                }
                &.otherColors{
                  background-color: #01A887;
                }
              }

              .pie-detail-num {
                font-size: 25px;
                color: #a0a2ac;
                height: 28px;
                font-weight: bold;
              }

              .pie-detail-title {
                font-size: 14px;
                color: #a0a2ac;
                padding-top: 10px;
              }
            }
          }
        }
      }
      .noticeBottom{
        width: 100%;
        height: 197px;
        padding: 23px 27px;
        box-sizing: border-box;
        background: #fff;
        // background: #111;
        margin-top: 16px;
        border-radius: 6px;
        .block{
          .demonstration{
            color: #50556D;
            font-size: 16px;
            font-weight: 600;
            display: inline-block;
          }
          ul{
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
          }
          .carousrBox{
            width: 60px;
            height: auto;
            .img{
              width: 60px;
              height: 60px;
              margin-bottom: 16px;
              img{
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            p{
              text-align: center;
            }
          }
        }
        .el-carousel{
          padding-top: 15px;
        }
        .el-carousel__indicator--horizontal{
          .el-carousel__button{
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #CFD4DC;
          }
        }
        .el-carousel__indicator{
          &.is-active{
            button{
              background: #1B75FB;
            }
          }
        }
      }
      .noticeLists {
        padding-left: 0;
        padding-right: 10px;
        .noticeList {
          background-color: #fff;
          width: 100%;
          border: 1px solid #e6e6e6;
          box-sizing: border-box;
          &.notice-company {
            height: 230px;
            margin-bottom: 10px;
            .title {
              height: 36px;
              border-bottom: 1px solid #e6e6e6;
              line-height: 36px;
              font-size: 15px;
              p {
                float: left;
                margin-left: 10px;
                &.more {
                  font-size: 12px;
                  margin-right: 10px;
                  float: right;
                  color: #666;
                  cursor: pointer;
                  &:hover{
                    color:$mainColor
                  }
                }
              }
            }
            .content {
              width: 100%;
              height: 183px;
              overflow: hidden;
              ul {
                padding-left: 0;
                margin: 10px;
                li {
                  margin-bottom: 10px;
                  line-height: 26px;
                  overflow: hidden; 
                  .boll {
                    display: inline-block;
                    float: left;
                    width: 6px;
                    height: 6px;
                    margin-top: 10px;
                    border-radius: 3px;
                    background-color: #bfd4f1;
                    margin-left: 5px;
                    vertical-align: middle;
                  }
                  p {
                    float: left;
                    width: calc(60% - 26px);
                    margin-left: 10px;
                    line-height: 26px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    word-wrap:break-word;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                  }
                  .version-update-time {
                      color:#999;
                      float:right
                  }
                }
              }
            }
          }
          &.notice-system {
            height: 250px;
            .title {
              height: 36px;
              border-bottom: 1px solid #e6e6e6;
              line-height: 36px;
              font-size: 15px;
              p {
                float: left;
                margin-left: 10px;
                &.more {
                  font-size: 12px;
                  margin-right: 10px;
                  float: right;
                  color: #666;
                  cursor: pointer;
                  &:hover{
                    color:$mainColor
                  }
                }
              }
            }
            .content {
              width: 100%;
              height: 203px;
              overflow: hidden;
              ul {
                padding-left: 0;
                margin: 10px;
                li {
                  margin-bottom: 16px;
                  line-height: 26px;
                  .boll {
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 3px;
                    background-color: #bfd4f1;
                    margin-left: 5px;
                    vertical-align: middle;
                  }
                  p {
                    display: inline-block;
                    margin-left: 10px;
                    line-height: 26px;
                  }
                  .version-update-time {
                      color:#999;
                      float:right
                  }
                }
              }
            }
          }
        }
      }
    }
    .index-notice-module-right {
      float: left;
      background-color: #fff;
      // width: calc(100% - 67% * 0.33333);
      width: calc(67% - 10px);
      margin-right: 10px;
      height: 100%;
      // border: 1px solid #e6e6e6;
      box-sizing: border-box;
      position: relative;
      border-radius: 6px;
      .el-tabs__header{
        margin: 4px 0 0!important;
      }
      .el-tabs__item{
        color: #4F556D!important;
        &.is-active {
          color: #50556D!important;
          font-weight: bold!important;
        }
        &:hover {
          color: #50556D!important;
          font-weight: bold!important;
        }
      }
      .tableCell{
        position: relative;
        .more{
          position: absolute;
          top: -55px;
          right: 28px;
          color: $mainColor;
          line-height: 36px;
        }
        .el-table{
          td{
            padding: 8px 0;
          }
        }
      }
      .circleBox{
        // width:25%;
        // flex: 1;
        width: 206px;
        float:left;
        padding:37px 6px 37px 24px;
        box-sizing: border-box;
        .topTip{
          font-size: 16px;
          color: #4F556D;
          margin-bottom: 60px;
        }
        .progressBox{
          width: 169px;
          height: auto;
          margin: 0 auto;
          position: relative;
          .el-progress-circle{
            width: 169px!important;
            height: 169px!important;
          }
          .progressNav{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            text-align: center;
            p{
              font-size: 16px;
              color: $mainColor;
              line-height: 37px;
              span{
                color: #FF691F;
                font-size: 36px;
                font-weight: bold;
              }
            }
          }
        }
        .progressBtn{
          width: 100%;
          .el-button{
            display: inherit;
            margin: 16px auto 0;
          }
          .el-button--primary{
            background-color: #1183ED;
            border-color: #1183ED;
          }
        }
      }
      .tableBox{
        width: calc(100% - 206px);
        float:left;
        padding: 39px 24px 0;
        .el-tabs__header {
          border-bottom: 0;
          .el-tabs__nav-wrap {
            &::after {
              height: 1px;
              background-color: #e6e6e6;
            }
            .el-tabs__nav-scroll {
              margin-left: 0!important;
              .el-tabs__nav {
                border-bottom: 1px solid #E4E7ED;
                .el-tabs__active-bar {
                  background-color: $mainColor;
                  height: 2px;
                }
                .el-tabs__item {
                  line-height: 37px;
                  color: #999;
                  &.is-active {
                    color: #ffffff!important;
                    font-weight: bold!important;
                    background: #4F556D;
                  }
                  &:hover {
                     color: #ffffff!important;
                    font-weight: bold!important;
                    background: #4F556D;
                  }
                }
              }
              .el-tabs__item{
                padding: 0 10px;
              }
            }
          }
        }
        .more {
          // position: absolute;
          // right: 34px;
          // top: 96px;
          float: right;
          line-height: 50px;
          color: #9699A5;
          cursor: pointer;
          z-index: 4;
          position: relative;
          width: 40px;
          height: 20px;
          a{
            position: absolute;
            top: 0;
            right: 0;
          }
          &:hover{
          color:$mainColor
          }
        }
      }
      .el-tabs__header {
        margin: 0;
        .el-tabs__nav-wrap {
          &::after {
            height: 1px;
            background-color: #e6e6e6;
          }
          .el-tabs__nav-scroll {
            margin-left: 10px;
            .el-tabs__nav {
              height: 38px;
              .el-tabs__active-bar {
                background-color: #50556D;
                height: 2px;
              }
              .el-tabs__item {
                line-height: 37px;
                &.is-active {
                  color: #50556D!important;
                  font-weight: bold!important;
                }
                &:hover {
                  color: #50556D!important;
                  font-weight: bold!important;
                }
              }
            }
            .el-tabs__item{
              padding: 0 10px;
            }
          }
        }
      }
      .table {
        width: 100%;
        height: 350px;
        .table_title {
          height: 56px;
          line-height: 56px;
          overflow: hidden;
          border-bottom: 1px solid #ebeef5;
          padding-left: 0;
          display: flex;
          background: #F7F7F7;
          margin-top: 16px;
          li {
            line-height: 56px;
            color: #333;
            float: left;
            // border-right: 1px solid #ebeef5;
            padding-left: 10px;
            &:nth-child(1) {
              flex: 3;
            }
            &:nth-child(1) {
              flex: 4;
            }
            &:nth-child(2) {
              flex: 2.5;
            }
            &:nth-child(3) {
              flex: 3;
            }
            &:nth-child(4) {
              flex: 3;
            }
          }
        }

        .table_content {
          overflow-y: hidden;
          // height: 400px;
          height: auto;
          padding-left: 0;
          .table_lists {
            .listsBox {
              height: 56px;
              line-height: 56px;
              box-sizing: border-box;
              min-height: 29px;
              padding: 10px 0;
              border-bottom: 1px solid #ebeef5;
              vertical-align: middle;
              &:nth-child(2n) {
                background-color: #fafafa;
              }
              &:hover {
                background-color: #f5f7fa;
              }
              .lists {
                height: 100%;
                display: flex;
                .list {
                  line-height: 39px;
                  color: #9093a6;
                  padding-left: 10px;
                  color: #606266;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  word-wrap:break-word;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  &:nth-child(1) {
                    flex: 4;
                  }
                  &:nth-child(2) {
                    flex: 2.5;
                  }
                  &:nth-child(3) {
                    flex: 3;
                  }
                  &:nth-child(4) {
                    flex: 3;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .publicBg {
    background-color: #fff;
    border-radius: 6px;
    width: calc(50% - 5px);
    &.fl {
      float: left;
      &:nth-child(2n) {
        margin-left: 10px;
      }
    }
  }
  .publicBgs{
    background-color: #fff;
    border-radius: 6px;
    width: calc(100% - 5px);
    &.fl {
      float: left;
      &:nth-child(2n) {
        margin-left: 10px;
      }
    }
  }
  .analyze-wrap{
	  display: flex;
	  flex-wrap: wrap;
	  justify-content: space-between;
  }
  .index-total-analyze {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;

    .index-total-analyze-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px;
      margin-bottom: 15px;
      width: 19%;

      .total-analyze-item-icon {
        margin-right: 15px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        padding: 10px 0 0 10px;
        background-color: #3a8ee6;
        .svg-icon {
          width: 40px;
          height: 40px;
          margin-top: 0;
        }
      }

      .total-analyze-item-desc {
        color: #333;
        font-size: 12px;
        line-height: 20px;

        .desc-title {
          font-size: 14px;
          color: #333;
        }
        .desc-count {
          color: #428efe;
          font-size: 30px;
          font-weight: bold;
          padding-bottom: 10px;
          text-align: center;
        }
      }
    }
  }

  .index-service-analyze {
    padding: 24px 28px;
    margin-bottom: 15px;
  }

  .index-evaluate-area {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;

    & > div {
      flex: 1;
      padding: 24px 28px;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .index-evaluate-analyze {
    padding: 0 28px;
    margin-bottom: 15px;
  }
  .index-map {
    display: flex;
    .area-data {
      width: 40%;
      font-size: 12px;
      color: #666;
      .data-detail {
        display: flex;
        align-items: center;
        .countNum {
          margin-right: 10px;
        }
        .progressBar {
          flex: 1;
        }
      }
    }
  }
  .index-services-activity {
    padding:0 28px;
	max-height: 600px;
	position: relative;
	.more {
	  position: absolute;
	  right: 38px;
	  top:26px;
	  font-size: 12px;
	  color: #666;
	  cursor: pointer;
	  &:hover{
	    color:$mainColor
	  }
	}
	.el-table__body-wrapper{
		// height: 455px;
    height: auto;
	}
	.el-table .cell{
		white-space: nowrap;
	}
    .pagenations {
      padding-top: 45px;
    }
    .index-table {
      margin-top: 51px;
    }
    .onlineSta {
      img {
        width: 14px;
        display: inline-block;
        vertical-align: middle;
        margin: -4px 2px 0;
        &.mgt5 {
          width: 18px;
        }
      }
    }
    .table-image-avatar {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    .tb-btn-operate {
      border-color: #428efe;
      color: #428efe;
    }

    .onlineStatus {
      &.online {
        color: $mainColor;
      }

      &.offline {
      }

      &.rest {
        color: $mainColor;
      }
    }
  }

  .line-chart-nodata {
    text-align: center;
    line-height: 380px;
  }
  .pie-chart-nodata {
    text-align: center;
    line-height: 480px;
  }
  .noData{
	  width: 100%;
	  text-align: center;
	  padding-top: 50px;
	  color: #999;
  }
  .content .noData{
	  padding-top: 80px;
  }
  .table_content .noData{
	  padding-top: 120px;
  }
}
</style>
